export class ContactoFilter {
  nombre?: string;
  puesto?: string;
  uniOrganizacional?: string;
  entidad?: string;
}
